export { default } from './svg/chevron-down.svg';
